import { Typography } from "@mui/material";

export default function H6({ children }) {
	return (
		<Typography variant="h6" gutterBottom component="div">
			{children}
		</Typography>
	);
}
